import * as React from 'react';
import {useEffect, useState} from 'react';
import withWidth from "@mui/material/Hidden/withWidth";
import {NavLink, useNavigate} from "react-router-dom";
import {Badge, ListItemIcon, ListItemText, MenuItem, MenuList, Stack, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import './AppDrawer.css';
import {isAdmin, isExploitant, Role} from "../../../utils/roles";
import {anomaliesActions} from "../../../modules/anomalies/anomalies.actions.js";
import Constants from "../../../utils/constants";
import {helper} from "../../../utils/helper";
import packageEnv from '../../../../package.json';
import {ClipboardCheck} from '@styled-icons/bootstrap/ClipboardCheck'
import {Home} from '@styled-icons/feather/Home'
import {User} from '@styled-icons/feather/User'
import {Trash} from '@styled-icons/feather/Trash'
import {Speedometer2} from '@styled-icons/bootstrap/Speedometer2'
import {TaskListLtr} from '@styled-icons/fluentui-system-regular/TaskListLtr'
import {Gear} from '@styled-icons/evil/Gear'
import {Truck} from '@styled-icons/feather/Truck'
import {WorkOutline} from '@styled-icons/material-sharp/WorkOutline'
import {Payments} from '@styled-icons/material-outlined/Payments'
import BusinessIcon from '@mui/icons-material/Business';
import WorkIcon from '@mui/icons-material/Work';
import WcIcon from '@mui/icons-material/Wc';
import RuleIcon from '@mui/icons-material/Rule';
import SchemaIcon from '@mui/icons-material/Schema';
import styled from "styled-components";
import {ClockIcon} from "@mui/x-date-pickers";
import DescriptionIcon from '@mui/icons-material/Description';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import {LaveuseIcon} from "../../../utils/ui/Icons/LaveuseIcon.js";
import {PlanningIcon} from "../../../utils/ui/Icons/PlanningIcon.js";
import GraffitiIcon from "../../../utils/ui/Icons/GraffitiIcon.js";
import TableChartIcon from '@mui/icons-material/TableChart';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {useGetMyExportsQuery, EXPORT_STATUS} from "../../../modules/exports/exports.api";
import AltRouteIcon from '@mui/icons-material/AltRoute';
import BetaBadge from './BetaBadge';

const WhiteSimulation = styled(AltRouteIcon)`color: white;
    width: 24px;`;
const WhiteTruckIcon = styled(Truck)`color: white;
    width: 24px;`;
const WhiteClipboard = styled(ClipboardCheck)`color: white;
    width: 24px;`;
const WhiteHome = styled(Home)`color: white;
    width: 24px;`;
const WhiteUsers = styled(User)`color: white;
    width: 24px;`;
const WhiteBin = styled(Trash)`color: white;
    width: 24px;`;
const WhiteDashboard = styled(Speedometer2)`color: white;
    width: 24px;`;
const WhiteForms = styled(TaskListLtr)`color: white;
    width: 24px;`;
const WhiteProblems = styled(Gear)`color: white;
    width: 24px;`;
const WhiteLaveuses = styled(Truck)`color: white;
    width: 24px;`;
const WhitePrestations = styled(WorkOutline)`color: white;
    width: 24px;`;
const WhiteConsignes = styled(InfoOutlinedIcon)`color: white;
    width: 24px;`;
const WhiteModesOp = styled(DescriptionIcon)`color: white;
    width: 24px;`;
const WhiteReferentiel = styled(CategoryIcon)`color: white;
    width: 24px;`;
const WhiteExploitation = styled(WorkIcon)`color: white;
    width: 24px;`;
const WhiteRH = styled(WcIcon)`color: white;
    width: 24px;`;
const WhiteControleQualite = styled(RuleIcon)`color: white;
    width: 24px;`;
const WhiteRHData = styled(SchemaIcon)`color: white;
    width: 24px;`;
const WhiteSuiviHeures = styled(ClockIcon)`color: white;
    width: 24px;`;
const WhiteFicheChantier = styled(DescriptionIcon)`color: white;
    width: 24px;`;
const WhiteValidationHeures = styled(FactCheckIcon)`color: white;
    width: 24px;`;
const WhitePeriodePaies = styled(Payments)`color: white;
    width: 24px;`;
const WhiteLaveuseIcon = styled(LaveuseIcon)`color: white;`
const WhiteGraffiti = styled(GraffitiIcon)`color: white;`
const WhiteAgences = styled(BusinessIcon)`color: white;
    width: 24px;`;
const WhiteReporting = styled(TableChartIcon)`color: white;
    width: 24px;`;
const WhiteExports = styled(FileDownloadIcon)`color: white;
    width: 24px;`;
const WhitePlanning = () => {
    return (<PlanningIcon fontSize={24} color={"white"}/>)
}


function AppDrawer({open}) {
    const [changelogOpen, setChangelogOpen] = useState(false);
    const [changelog, setChangelog] = useState();
    const [exploitationSubmenuOpen, setExploitationSubmenuOpen] = useState(false);
    const [rhSubmenuOpen, setRhSubmenuOpen] = useState(false);
    const navigate = useNavigate();
    const currentUser = helper.getCurrentUser();
    const dispatch = useDispatch();
    const anomaliesCount = useSelector(state => state.anomalies?.count ?? 0);

    // Badge Contrôle Qualité : count au montage puis polling.
    // Même condition que l'entrée de menu (ADMIN + EXPLOITANT), sinon un admin
    // n'a jamais de polling et le badge ne vit qu'en entrant sur l'écran.
    useEffect(() => {
        if (!isExploitant() && !isAdmin()) return;

        dispatch(anomaliesActions.fetchAnomaliesCount());
        const interval = setInterval(() => {
            dispatch(anomaliesActions.fetchAnomaliesCount());
        }, Constants.ANOMALIES_COUNT_POLLING_MS);

        return () => clearInterval(interval);
    }, [dispatch]);

    // Icône Contrôle Qualité avec badge du nombre d'anomalies à traiter
    const ControleQualiteIconWithBadge = () => (
        <Badge badgeContent={anomaliesCount} color="error" max={99}>
            <WhiteControleQualite/>
        </Badge>
    );

    // Badge « Mes exports » : nombre d'exports prêts non consultés. Pas de polling
    // dédié — l'ExportsWatcher invalide le tag 'Exports' quand un export se termine,
    // et la page Mes exports remet le compteur à zéro (POST /exports/consulter).
    const {data: doneExports} = useGetMyExportsQuery({statuts: [EXPORT_STATUS.DONE]});
    const unreadExportsCount = (doneExports || []).filter((e) => !e.consulteAt).length;

    const MesExportsIconWithBadge = () => (
        <Badge badgeContent={unreadExportsCount} color="error" max={99}>
            <WhiteExports/>
        </Badge>
    );

    useEffect(() => {
        import('../../../changelog.md')
            .then((module) => fetch(module.default))
            .then(response => response.text())
            .then(text => setChangelog(text))
            .catch(error => console.error('Erreur lors du chargement du changelog:', error));
    }, []);

    const getAppVersion = () => {
        let appVersion = `version du ${packageEnv.versionDate} ${packageEnv.version}`;
        if (import.meta.REACT_APP_ENV === "beta") {
            appVersion += "-BETA";
        }
        return appVersion;
    };

    const renderMenuItem = (to, IconComponent, text, roles = []) => {
        if (roles?.length === 0 || roles?.some(role => currentUser?.roles?.includes(role))) {
            return (
                <NavLink to={to}
                         className={({isActive}) =>
                             `drawerMenuNavlink ${isActive ? 'active' : ''}`
                         }
                >
                    <MenuItem>
                        <ListItemIcon>
                            <IconComponent/>
                        </ListItemIcon>
                        <ListItemText>
                            <Typography sx={{color: 'white', display: 'inline'}}>{text}</Typography>
                        </ListItemText>
                    </MenuItem>
                </NavLink>
            );
        }
        return null;
    };

    // Détermination dynamique des menus à afficher pour les clients selon leurs services souscrits
    const roles = Array.isArray(currentUser?.roles) ? currentUser.roles : [];
    const isClient = roles.includes(Role.ROLE_CLIENT);
    // Supporte à la fois "serviceTypes" (clé utilisée dans l'app) et "serviceType" (clé potentielle du JWT)
    const rawServiceTypes = Array.isArray(currentUser?.serviceTypes)
        ? currentUser.serviceTypes
        : (Array.isArray(currentUser?.serviceType) ? currentUser.serviceType : []);
    const serviceTypes = rawServiceTypes.map(s => String(s).toLowerCase());
    const hasGraffiti = serviceTypes.includes('graffiti');
    const hasLavage = serviceTypes.includes('lavage');

    return (
        <div className={`drawer-v2 ${open ? 'drawer-open' : 'drawer-minimized'}`}>
            <Stack direction={"column"} className={"appDrawer-menu-container"}>
                <MenuList>
                    {renderMenuItem(Constants.APP_ROUTE_DASHBOARD, WhiteDashboard, 'Tableau de bord', [Role.ROLE_EXPLOITANT])}
                    {renderMenuItem(Constants.APP_ROUTE_LAVEUSES_TRACKING_PAGE, WhiteLaveuseIcon, 'Laveuses', [Role.ROLE_EXPLOITANT])}
                    {renderMenuItem(Constants.APP_ROUTE_PLANNING_GSHEET, WhitePlanning, 'Planning', [Role.ROLE_EXPLOITANT])}
                    {/* Affichage conditionnel pour les clients selon leurs services */}
                    {(!isClient || hasLavage) && renderMenuItem(
                        Constants.APP_ROUTE_PATRIMOINE,
                        WhiteBin,
                        'Patrimoines',
                        [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT]
                    )}
                   {/* {(!isClient || hasLavage) && renderMenuItem(
                        Constants.APP_ROUTE_PATRIMOINE_V2,
                        WhiteBin,
                        'Patrimoine v2',
                        [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT]
                    )}*/}
                    {(!isClient || hasGraffiti) && renderMenuItem(
                        Constants.APP_ROUTE_GRAFFITI_PATRIMOINE,
                        WhiteGraffiti,
                        'Graffiti',
                        [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT]
                    )}
                    {renderMenuItem(Constants.APP_ROUTE_SYNTHESE, WhiteClipboard, 'Synthèse', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT])}
                    {/* Tous rôles : chacun ne voit que ses propres exports */}
                    {renderMenuItem(Constants.APP_ROUTE_MES_EXPORTS, MesExportsIconWithBadge, 'Mes exports', [])}
                    {renderMenuItem(Constants.APP_ROUTE_REPORTING_TOURNEES, WhiteReporting, 'Reporting tournées', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
                    {/* TOUR-03 : simulateur de découpage (bêta). Pas de section « Tournées & circuits » dans le menu actuel : posé à côté de Reporting tournées, visible ADMIN + EXPLOITANT. */}
                    {renderMenuItem(Constants.APP_ROUTE_SIMULATIONS, WhiteSimulation, <>Simulateur<BetaBadge/></>, [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}

                    {isExploitant() &&
                        <>
                            <hr className={'drawer-divider'}/>
                            <p className={`drawer-subheader ${open ? "visible" : "hidden"}`}>
                                Exploitation
                            </p>
                            {renderMenuItem(Constants.APP_ROUTE_ADMIN_CAMPAIGNS, WhiteTruckIcon, 'Tournées', [Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_CONTROLE_QUALITE, ControleQualiteIconWithBadge, 'Contrôle Qualité', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_ADMIN_USERS, WhiteUsers, 'Utilisateurs', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
                        </>
                    }

                    {isExploitant() &&
                        <>
                            <hr className={'drawer-divider'}/>
                            <p className={`drawer-subheader ${open ? "visible" : "hidden"}`}>
                                Ressources Humaines
                            </p>
                            {renderMenuItem(Constants.APP_ROUTE_ADMIN_RH_DATA, WhiteRHData, 'Données RH', [Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_RH_PERIODE_PAIES, WhitePeriodePaies, 'Période de paies', [Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_RH_SUIVIHEURES, WhiteSuiviHeures, 'Suivi des heures', [Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_RH_FICHECHANTIER, WhiteFicheChantier, 'Fiche suivi', [Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_RH_VALIDATION_HEURES, WhiteValidationHeures, 'Validation des heures', [Role.ROLE_EXPLOITANT])}
                        </>
                    }

                    {isExploitant() &&
                        <>
                            <hr className={'drawer-divider'}/>
                            <p className={`drawer-subheader ${open ? "visible" : "hidden"}`}>
                                Données
                            </p>
                            {renderMenuItem(Constants.APP_ROUTE_ADMIN_REFERENTIEL, WhiteReferentiel, 'Référentiel', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
                            {renderMenuItem(Constants.APP_ROUTE_ADMIN_LAVEUSES, WhiteLaveuses, 'Laveuses', [Role.ROLE_EXPLOITANT])}
                        </>
                    }
                </MenuList>

            </Stack>
        </div>
    )

    // return (
    //     <Grid container direction="row" justifyContent="space-between" style={{height: '100vh', padding: '1rem'}}>
    //         <Grid size={12}>
    //
    //             {/*<div className={import.meta.REACT_APP_ENV === "beta" ? "app-version version-beta" : "app-version"}>*/}
    //             {/*    {getAppVersion()}*/}
    //             {/*    <IconButton sx={{color: 'white'}} onClick={() => setChangelogOpen(true)}>*/}
    //             {/*        <HelpOutline/>*/}
    //             {/*    </IconButton>*/}
    //             {/*</div>*/}
    //             <Grid item className={"pt-2 appDrawer-menu-container"}>
    //                 <MenuList>
    //                     {renderMenuItem(Constants.APP_ROUTE_HOME, WhiteHome, 'Accueil')}
    //                     {renderMenuItem(Constants.APP_ROUTE_DASHBOARD, WhiteDashboard, 'Tableau de bord', [Role.ROLE_EXPLOITANT])}
    //                     {renderMenuItem(Constants.APP_ROUTE_PATRIMOINE, WhiteBin, 'Patrimoines', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT])}
    //                     {renderMenuItem(Constants.APP_ROUTE_SYNTHESE, WhiteClipboard, 'Synthèse', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT])}
    //
    //                     {/* Menu déroulant Exploitation */}
    //                     {isExploitant() &&
    //                         <>
    //                             <MenuItem onClick={() => setExploitationSubmenuOpen(!exploitationSubmenuOpen)}
    //                                       sx={{height: '55px'}}>
    //                                 <ListItemIcon>
    //                                     <WhiteExploitation/>
    //                                 </ListItemIcon>
    //                                 <ListItemText>
    //                                     <Typography sx={{color: 'white', display: 'inline'}}>Exploitation</Typography>
    //                                 </ListItemText>
    //                                 {exploitationSubmenuOpen ? <ExpandLess sx={{color: 'white'}}/> :
    //                                     <ExpandMore sx={{color: 'white'}}/>}
    //                             </MenuItem>
    //                             <Collapse in={exploitationSubmenuOpen} timeout="auto" unmountOnExit
    //                                       sx={{paddingLeft: ".75rem"}}>
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_CAMPAIGNS, WhiteTruckIcon, 'Tournées de lavage', [Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_USERS, WhiteUsers, 'Gestion des utilisateurs', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_FORMS, WhiteForms, 'Gestion des formulaires', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_LAVEUSES, WhiteLaveuses, 'Gestion des laveuses', [Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_PROBLEMS, WhiteProblems, 'Gestion des problèmes', [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_PRESTATIONS, WhitePrestations, 'Gestion des prestations', [Role.ROLE_EXPLOITANT])}
    //                             </Collapse>
    //
    //                             <MenuItem onClick={() => setRhSubmenuOpen(!rhSubmenuOpen)} sx={{height: '55px'}}>
    //                                 <ListItemIcon>
    //                                     <WhiteRH/>
    //                                 </ListItemIcon>
    //                                 <ListItemText>
    //                                     <Typography sx={{color: 'white', display: 'inline'}}>Ressources
    //                                         Humaines</Typography>
    //                                 </ListItemText>
    //                                 {rhSubmenuOpen ? <ExpandLess sx={{color: 'white'}}/> :
    //                                     <ExpandMore sx={{color: 'white'}}/>}
    //                             </MenuItem>
    //                             <Collapse in={rhSubmenuOpen} timeout="auto" unmountOnExit
    //                                       sx={{paddingLeft: ".75rem"}}>
    //                                 {renderMenuItem(Constants.APP_ROUTE_ADMIN_RH_DATA, WhiteRHData, 'Données RH', [Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_RH_PERIODE_PAIES, WhitePeriodePaies, 'Période de paies', [Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_RH_SUIVIHEURES, WhiteSuiviHeures, 'Suivi des heures', [Role.ROLE_EXPLOITANT])}
    //                                 {renderMenuItem(Constants.APP_ROUTE_RH_FICHECHANTIER, WhiteFicheChantier, 'Fiche suivi de chantier', [Role.ROLE_EXPLOITANT])}
    //                             </Collapse>
    //                         </>
    //                     }
    //
    //
    //                 </MenuList>
    //             </Grid>
    //             <img src={"/images/poubelle-alpha.png"} alt={"poubelle"} className={"filigrane-poubelle"}/>
    //         </Grid>
    //
    //         <Dialog
    //             open={changelogOpen}
    //             onClose={() => setChangelogOpen(false)}
    //             aria-labelledby="alert-dialog-title"
    //             aria-describedby="alert-dialog-description"
    //         >
    //             <DialogTitle id="alert-dialog-title">
    //                 Notes de mise à jour
    //             </DialogTitle>
    //             <DialogContent>
    //                 <DialogContentText>
    //                     <ReactMarkdown>{changelog}</ReactMarkdown>
    //                 </DialogContentText>
    //             </DialogContent>
    //             <DialogActions>
    //                 {/* Add any actions needed */}
    //             </DialogActions>
    //         </Dialog>
    //     </Grid>
    // );
}

export default withWidth()(AppDrawer);
